import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const TopNavigationTabBarStyles = StyleSheet.create({
	buttonGroup: {
		backgroundColor: colorList.PRIMARY.lighter,
		flexDirection: 'row',
		paddingVertical: 3,
		alignSelf: 'center',
		marginTop: 0,
		marginBottom: 5,
		margin: 6,
		borderRadius: 10,
		borderWidth: 1,
		borderColor: colorList.PRIMARY.light,
	},
	
	button: {
		marginHorizontal: 3,
		paddingVertical: 8,
		paddingHorizontal: 14,
		justifyContent: 'flex-start',
	},
	
	buttonContent: {
		alignSelf: 'flex-start'
	},
	
	buttonActive: {
		opacity: 1,
		backgroundColor: colorList.PRIMARY.dark,
		borderRadius: 8
	},
	
	buttonText: {
		width: '100%',
		fontWeight: '700',
		fontSize: 13,
		color: colorList.TEXT.light,
	},
	buttonTextActive: {
		color: colorList.WHITE.primary
	},
	
	buttonBadge: {
		position: 'absolute',
		alignSelf: 'center',
		top: -15,
		right: -5,
	},
	
	activeDot: {
		backgroundColor: colorList.WHITE.primary,
		alignSelf: 'flex-start',
		width: '100%',
		height: 4,
		borderRadius: 4,
		marginTop: 3,
		opacity: 0.9
	}
});
